export const uk = {
    format: 'Формат',
    operatorName: 'Оператор',
    selected: 'Выбранные'
};
